import { ReactElement } from 'react'
import _ from 'lodash'
import { NavLink } from 'react-router-dom'
import { Tooltip, Badge } from '@mui/material'

// types
import type { NavLinkSpec } from 'types/route'

// utils
import { useStaticResourceStateValue } from 'contexts'

import scss from './index.module.scss'

const NavItem = ({
  name,
  path,
  icon,
  iconSize = 19,
  enabled = true,
  badgeCount,
}: NavLinkSpec): ReactElement | null => {
  const { Icons } = useStaticResourceStateValue()

  if (!enabled) return null

  const Icon = _.get(Icons, icon) || Icons.AiFillAppstore

  return (
    <NavLink
      data-testid={name}
      to={path}
      className={({ isActive }) =>
        `${scss.navLink} ${isActive ? scss.active : ''}`
      }
    >
      <Tooltip title={name} placement='right' arrow>
        <div className={scss.sidebarIcon}>
          <div className={scss.iconWrapper}>
            <Badge
              badgeContent={badgeCount}
              color='error'
              invisible={!badgeCount}
            >
              <Icon size={iconSize} color='#fff' />
            </Badge>
          </div>
        </div>
      </Tooltip>
    </NavLink>
  )
}

export default NavItem
